export const TEST_ID_TOURIST_NAME_OPTION = 'TEST_ID_TOURIST_NAME_OPTION';

export const TEST_ID_TOURIST_NAME_OPTION_DELETE_ICON =
  'TEST_ID_TOURIST_NAME_OPTION_DELETE_ICON';
